export default function getDateKey(date: Date) {
  return date
    .toLocaleDateString("ru", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    })
    .replaceAll(".", "-");
}
